<template>
    <!-- Section: boxes -->
    <section id="boxes" class="home-section paddingtop-80 paddingbot-60">
      <div class="container">
        <div class="row">
          <div class="col-sm-3 col-md-3">
            <div class="wow fadeInUp" data-wow-delay="0.2s">
              <div class="box text-center">
                <div class="bg-skin image-icon-container">
                  <img src="image/homeboxes/incense.png" alt="" class="bg-skin image-icon-circle">
                </div>              
                <h4 class="h-bold">{{box1_title}}</h4>
                <p>
                  {{box1_text}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="wow fadeInUp" data-wow-delay="0.2s">
              <div class="box text-center">
                <div class="bg-skin image-icon-container">
                  <img src="image/homeboxes/acupuncture.png" alt="" class="bg-skin image-icon-circle">
                </div>                
                <h4 class="h-bold">{{box2_title}}</h4>
                <p>
                   {{box2_text}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="wow fadeInUp" data-wow-delay="0.2s">
              <div class="box text-center">
                <div class="bg-skin image-icon-container">
                  <img src="image/homeboxes/leech.png" alt="" class="bg-skin image-icon-circle">
                </div>                
                <h4 class="h-bold">{{box3_title}}</h4>
                <p>
                   {{box3_text}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="wow fadeInUp" data-wow-delay="0.2s">
              <div class="box text-center">
                <div class="bg-skin image-icon-container">
                <img src="image/homeboxes/therapy.png" alt="" class="bg-skin image-icon-circle">
                </div>                
                <h4 class="h-bold">{{box4_title}}</h4>
                <p>
                   {{box4_text}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /Section: boxes -->
</template>

<script>
  export default {
    data: ()=>{
      return {
        box1_title : '',
        box1_text : '',
        box2_title : '',
        box2_text : '',
        box3_title : '',
        box3_text : '',
        box4_title : '',
        box4_text : '',
        direction: "",
        direction_class: "",
      }
    },
    methods:{
      changeLanguage(){
        console.log("Homeboxes language ############################# 2")
        this.box1_title = this.$store.getters.SOURCE_JSON.home.box1_title
        this.box1_text = this.$store.getters.SOURCE_JSON.home.box1_text
        this.box2_title = this.$store.getters.SOURCE_JSON.home.box2_title
        this.box2_text = this.$store.getters.SOURCE_JSON.home.box2_text
        this.box3_title = this.$store.getters.SOURCE_JSON.home.box3_title
        this.box3_text = this.$store.getters.SOURCE_JSON.home.box3_text
        this.box4_title = this.$store.getters.SOURCE_JSON.home.box4_title
        this.box4_text = this.$store.getters.SOURCE_JSON.home.box4_text
        
        this.direction = this.$store.getters.CURRENT_LANGUAGE === "he_IL" ? "rtl" : "ltr";
      }
    },
    created(){
      this.changeLanguage();

      this.$store.subscribe((mutation, state) => {
          if(mutation.type === 'SET_CURRENT_LANGUAGE'){
             console.log("Homeboxes language ############################# 1")                   
             this.changeLanguage();          
          }
      })     
    }
  }
</script>

<style scope>
  .image-icon-container{
    width: 100px;
    height: 100px;
    text-align: center;
    padding: 15px;
    border-radius: 50%;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 15px;
  }

  .image-icon-circle{
    width: 100%;
    height: 100%;
    border-radius: 35%;
  }

  .wow.fadeInUp{
    visibility: visible !important;
  }

</style>